<ion-content class="ion-padding">
  <ion-grid style="height: 100%">
    <ion-row class="ion-align-items-center ion-justify-content-center">
      <ion-icon src="/assets/icon/expreso.svg" color="primary"></ion-icon>
      <h3>Transporte</h3>
      <p>¡Todo listo!</p>
      <p>Aquí está tu boleto.</p>
      <h3>¡Buen viaje!</h3>
      <ion-button shape="round" color="primary" expand="block" (click)="closeModal()">Ver boleto</ion-button>
    </ion-row>
  </ion-grid>
</ion-content>
